import React, { useState, useEffect, ChangeEvent } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputLabel,
  SelectChangeEvent,
  Grid
} from "@mui/material";
import { useNotification } from "../../context/notification.context";
import { budget } from "../../api/budget";

type ModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  productId: string | undefined;
  initialData?: any | null;
};

export const ModalInvoiceComponent: React.FC<ModalProps> = ({
  open,
  onClose,
  title,
  productId,
  initialData,
}) => {
  const [formData, setFormData] = useState<any>({});
  const { getError, getSuccess } = useNotification();

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({});
    }
  }, [initialData]);

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | { name: string; value: unknown }> | SelectChangeEvent<any>,
  ) => {
    const { name, value } = event.target as HTMLInputElement;
    setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = async () => {   
    try { 
      const budgetData = {
        facturas: formData["facturas"]
      };
      if(productId !== undefined)
        await budget.updateInvoices(productId, budgetData);
      getSuccess("Facturas agregadas correctamente");
      setFormData({});
      onClose();
    } catch (error) {
      getError("Error al agregar las facturas: " + error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container sx={{ mt: 2, mb: 2 }}>
          <Grid item xs={12}>
            <InputLabel sx={{ mt: 1 }}>
              Facturas
            </InputLabel>
            <TextField
              key={"facturas"}              
              name={"facturas"}
              multiline={true}
              rows={3}
              fullWidth
              sx={{ mt: 0 }}
              value={formData["facturas"] || ""}
              onChange={handleChange}
            />
          </Grid>
        </Grid>     
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} style={{backgroundColor:"#ed3c3cde", color:"#000000"}}>Cancelar</Button>
        <Button onClick={handleSave} style={{backgroundColor:"#6da34cde", color:"#000000"}}>Guardar</Button>
      </DialogActions>
    </Dialog>
  );
};
